import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import BookReader from '../components/BookReader';

const ComicReader: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  const { volume, comicTitle, volumeTitle, comicId } = location.state || {};

  if (!volume || !volume.fileUrl) {
    return (
      <div>
        <p>Volume not found or not available.</p>
        <button onClick={() => navigate(-1)}>Go Back</button>
      </div>
    );
  }

  const handleClose = () => {
    // Navigate back to volumes page
    const comicIdFromPath = location.pathname.split('/')[2]; // Extract comic ID from path
    navigate(`/comic/${comicIdFromPath}/volumes`);
  };

  // Use the actual comic document ID for view tracking
  const actualComicId = comicId || location.pathname.split('/')[2];

  return (
    <BookReader
      bookId={actualComicId}
      bookTitle={`${comicTitle} - ${volumeTitle}`}
      bookFileUrl={volume.fileUrl}
      onClose={handleClose}
    />
  );
};

export default ComicReader;
